import { Checkout } from '@instamenu/context-checkout';
import { Alert } from '@instamenu/ui-system-next';
import { Fulfillment } from '@instamenu/data-access';

type CheckoutAlertProps = { checkout?: Checkout };

export const CheckoutAlert = ({ checkout }: CheckoutAlertProps) => {
  if (!checkout || !checkout.order || !checkout.restaurant.hours) return null;

  const isDelivery = checkout.mode === Fulfillment.Delivery;
  const showNoAddress = isDelivery && !checkout.order.deliveryAddress;
  const showOutOfRange =
    isDelivery &&
    !showNoAddress &&
    !checkout.deliveryQuoteFetching &&
    !checkout.deliveryQuote?.available;

  if (!checkout.restaurant.visible) {
    return (
      <Alert
        message="This location is not accepting online orders."
        severity="error"
        slide="down"
      />
    );
  }
  if (!checkout.restaurant.hours.isOpen) {
    return (
      <Alert
        message={
          checkout.order.maySchedule
            ? 'This location is closed right now. You can schedule an order for later.'
            : 'This location is closed right now.'
        }
        severity={checkout.order.maySchedule ? 'notify' : 'error'}
        slide="down"
      />
    );
  }
  if (showNoAddress) {
    return (
      <Alert message="Enter your address to see delivery details" severity="error" slide="down" />
    );
  }
  if (showOutOfRange) {
    return (
      <Alert message="This address is outside our delivery range" severity="error" slide="down" />
    );
  }
  return null;
};
